module.exports = __webpack_public_path__ + "static/media/purolatorbox.80ee696b.png";